<template>
	<div class="jtBon">
		<div class="kaoshiWtBtn supHove3" :style="{ marginLeft: types == 'zb' ? '0' : '' }" @click="btns">
			<img src="@/assets/img/形状.png" alt="" />
			精听
		</div>
		<div class="jtBox" :class="btnFlag ? 'jtBox1' : ''" :style="{ background: types == 'zb' ? '#fff' : '', left: types == 'zb' ? '63px' : '82px' }">
			<img src="@/assets/img/yliang.gif" class="yls" alt="" />
			<div class="jtqj">
				<div class="jtqjLeft" @click="htFn">
					<img src="@/assets/img/zwxz.svg" class="wxBox" alt="" />
					<img src="@/assets/img/zxz.svg" class="xzBox" alt="" />
					后退5秒
				</div>
				<div class="jtqjBtn" @click="bfFn">
					<img src="@/assets/img/bft.svg" v-show="!bfFlag" alt="" />
					<img src="@/assets/img/bfz.svg" v-show="bfFlag" alt="" />
				</div>
				<div class="jtqjRig" @click="qjFn">
					前进5秒
					<img src="@/assets/img/ywxz.svg" class="wxBox" alt="" />
					<img src="@/assets/img/yxz.svg" class="xzBox" alt="" />
				</div>
				<div class="jtqjSx" @click="czFn">
					<img src="@/assets/img/bfsx.svg" alt="" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'jtingView',
	data() {
		return {
			bfFlag: true,
			btnFlag: false
		};
	},
	props: ['types'],
	methods: {
		btns() {
			if (!this.btnFlag) {
				this.$emit('qkFn');
				this.$emit('btns');
				this.$audio.endedFn(this);
			}
			this.btnFlag = !this.btnFlag;
		},
		bfFn() {
			this.bfFlag = !this.bfFlag;
			if (this.bfFlag) {
				this.$audio.play();
			} else {
				this.$audio.pause();
			}
		},
		htFn() {
			this.$audio.rewind();
		},
		qjFn() {
			this.$audio.fastForward();
		},
		czFn() {
			this.$audio.resetFn();
			if (this.bfFlag) {
				this.$audio.play();
			} else {
				this.$audio.pause();
			}
		}
	}
};
</script>

<style scoped lang="scss">
.jtBon {
	position: relative;
}
.jtBox {
	display: flex;
	align-items: center;
	position: absolute;
	width: 0px;
	overflow: hidden;
	box-sizing: border-box;
	left: 82px;
	transition: all 0.3s;
	top: 0;
	.yls {
		width: 27px;
		height: 27px;
		margin: 0 10px 0 12px;
	}
	.jtqj {
		height: 26px;
		background: #ffffff;
		box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.02);
		border-radius: 4px;
		border: 1px solid #f6f6f6;
		display: flex;
		align-items: center;
		width: 231px;
		font-size: 12px;
		color: #333333;
		padding: 0 9px;
		box-sizing: border-box;
		justify-content: space-between;
		> div {
			display: flex;
			line-height: 1;
			align-items: center;
			cursor: pointer;
		}
		.active {
			color: #1d7b3a;
		}
		.jtqjLeft {
			width: 68px;
			img {
				margin-right: 4px;
				margin-top: 2px;
			}
			.xzBox {
				display: none;
			}
			&:hover {
				color: #1d7b3a;
				.wxBox {
					display: none;
				}
				.xzBox {
					display: block;
				}
			}
		}
		.jtqjRig {
			width: 68px;
			img {
				margin-left: 4px;
				margin-top: 2px;
			}
			.xzBox {
				display: none;
			}
			&:hover {
				color: #1d7b3a;
				.wxBox {
					display: none;
				}
				.xzBox {
					display: block;
				}
			}
		}
	}
}
.jtBox1 {
	width: 300px;
}
.kaoshiWtBtn {
	margin-left: 19px;
	width: 63px;
	height: 26px;
	background: #1d7b3a;
	border-radius: 4px;
	color: #fff;
	font-size: 14px;
	display: flex;
	justify-content: center;
	align-items: center;
	font-weight: 400;
	cursor: pointer;
	img {
		width: 16px;
		height: 14px;
		margin-right: 6px;
	}
}
</style>
